import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastService } from 'angular-toastify';
import { CardAdvance } from '../../../../core/models/card.model';
import { ApiService } from '../../../../core/services/api.service';
import { PssLoadingComponent } from "../../../../tools/template/pss/pss-loading/pss-loading.component";

@Component({
  selector: 'app-vehicle-card-future',
  imports: [
    CommonModule,
    FormsModule,
    PssLoadingComponent
  ],
  templateUrl: './vehicle-card-future.component.html',
  styleUrl: './vehicle-card-future.component.css'
})
export class VehicleCardFutureComponent {
  // CityparkingCardAdvance
  cityParkingCardAdvance: CardAdvance[] = [];
  // ( Date format )
  endDate: string = new Date().toISOString().slice(0, 10);
  startDate: string = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);

  // ✅ pagination state
  currentPage = 1;
  pageSize = 10;

  // Loading
  isLoading: boolean = false;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private cookieService: CookieService,
    private http: HttpClient,
    private toast: ToastService
  ) {
    this.isLoading = true;
    this.getCardAdvance()
  }

  /* --------------------------------------------------------- Function --------------------------------------------------------- */
  /* ---- style ---- */
  // Table
  get totalPages(): number {
    return Math.ceil(this.cityParkingCardAdvance.length / this.pageSize);
  }

  get paginatedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.cityParkingCardAdvance.slice(start, start + this.pageSize);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  /* ---- Function ---- */
  navigateToDetailCreate() {
    this.router.navigate([`/vehicle-card-future-detail`]);
    //console.log("id :", id , this.router.url);

  }
  navigateToDetailById(id: number) {
    this.router.navigate([`/vehicle-card-future-detail/${id}`]);
    //console.log("id :", id , this.router.url);
  }
  onSaveSearchByDate() {
    const today = new Date().toISOString().slice(0, 10);
    if (this.startDate > this.endDate) {
      this.toast.error('ต้องเลือกวันที่เริ่มต้น ก่อนวันที่สิ้นสุด');
      return;
    }
    else if (this.endDate > today) {
      this.toast.error('วันที่สิ้นสุดไม่สามารถเลือกในอนาคตได้');
      return;
    }

    // ดึงข้อมูล
    this.getCardAdvance().then(
      () => {
        this.toast.success('เรียกดูข้อมูลสําเร็จ');
      }
    );
  }
  /* --------------------------------------------------------- API --------------------------------------------------------- */
  async getCardAdvance() {
    this.apiService.getCardAdvance(this.startDate, this.endDate).subscribe({
      next: (res) => {
        //console.log('Response getCardAdvance :', res);
        this.cityParkingCardAdvance = res;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error fetching card advance:', err);
        this.toast.error('Error fetching card advance');
        this.isLoading = false;
      }
    });
  }

}
